import React, { useState } from 'react'
import grievanceRemarkServices from '../grievanceRemarkServices';
import { useAlert } from '../../../../../../context/AlertContext';

function GrievanceRemarkForm({grievanceId, callBack}) {
  
    const [remark,setRemark] = useState("");

    const {AppAlert} = useAlert();

    const saveRemark = () =>{
        let payload = {
            grievanceId:grievanceId,
            remark:remark
        }

        grievanceRemarkServices.save(payload).then(res=>{
            AppAlert(res.msg)
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }


    return (
        <div className='row'>
            <div className='col-md-12'>
                <div className="form-floating">
                    <textarea className="form-control" value={remark} onChange={(e)=>setRemark(e.target.value)} />
                    <label>Remark</label>
                </div>
            </div>
            <div className='col-md-12 mt-3'>
                <button className='btn btn-outline-primary float-end' onClick={saveRemark} >Submit</button>
            </div>
        </div>
    )
}

export default GrievanceRemarkForm